<template>
  <div class="home">
    <section class="hero is-custom is-fullheight-with-navbar">
      <div class="hero-body">
        <div class="container has-text-centered ">
          <p class="title is-1 has-text-white" style="font-size: 8em;">
            Lewis Relph
          </p>
          <p class="subtitle has-text-white">me@lewisrelph.com</p>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'Home',
  components: {
  }
}
</script>

<style>
  .is-custom {
    background: url(../assets/background.jpg) no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  }
</style>
